import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material'
import React from 'react'
import { any } from 'prop-types'

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }, ...props) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgba(245,245,245,1)',
    color: theme.palette.leitura.main,
    boxShadow: theme.shadows[1],
    fontSize: '1rem',
    padding: '0.3rem 0.6rem',
    fontWeight: 'bold',
    ...props
  }
}))
const BalckTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }, ...props) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '0.8rem',
    padding: '0.2rem 0.4rem',
    ...props
  }
}))

const BaseTooltip = ({ children, title, light = false, ...rest }) => {
  const Component = light ? LightTooltip : BalckTooltip

  return (
    <Component title={title} {...rest}>
      <div className="d-flex cursor-pointer">{children}</div>
    </Component>
  )
}

export default BaseTooltip

BaseTooltip.propTypes = {
  children: any,
  title: any,
  light: any
}
